import React from "react";
import "./SkeletonCompactPost.css";

const SkeletonCompactPost = () => {
  return (
    <div className="skeleton-compact-post">
      {/* Top: Avatar, username, timestamp */}
      <div className="scp-header">
        <div className="scp-avatar shimmer" />
        <div className="scp-userinfo">
          <div className="scp-line short shimmer" />
          <div className="scp-line xshort shimmer" />
        </div>
      </div>

      {/* Rating */}
      <div className="scp-stars shimmer" />

      {/* Media */}
      <div className="scp-media shimmer" />

      {/* Action icons */}
      <div className="scp-footer">
        <div className="scp-icon shimmer" />
        <div className="scp-icon shimmer" />
        <div className="scp-icon shimmer" />
        <div className="scp-icon shimmer" />
      </div>
    </div>
  );
};

export default SkeletonCompactPost;
